<form [formGroup]="additionalEducationForm" class="pad30 " *ngIf="isFormInit"
  (keydown)="disableEnterButton($event)">
  <div id="customFormSlide" class="p-b-20 overflhide">
    <div formArrayName="additionalEducationSubForm">
      <div *ngFor="let additionalEducationSubForm of additionalEducationForm.get('additionalEducationSubForm')['controls']; let i=index">
        <div class="mobile_container animated posrel"
          [class.slideInRight]="(currentSlideWithDirection === 'additionaleducationknockout_' + i + '_right') ? true : false"
          [class.slideInLeft]="(currentSlideWithDirection === 'additionaleducationknockout_' + i + '_left') ? true : false"
          [class.hide]="(currentSlide !== 'additionaleducationknockout_' + i) ? true:false">
          <additional-education-knockout
            [group]="additionalEducationForm.get('additionalEducationSubForm')['controls'][i]" [row]="i" [configOptions]="configOptions"
            (onAdditionalEducationKnockout)="empAdditionalEducationKnockout($event)" (onSaveExit)="saveExit()" > 
          </additional-education-knockout>
        </div>

        <div class="mobile_container animated posrel"
          [class.slideInRight]="(currentSlideWithDirection === 'additionaleducationdetails_' + i + '_right') ? true : false"
          [class.slideInLeft]="(currentSlideWithDirection === 'additionaleducationdetails_' + i + '_left') ? true : false"
          [class.hide]="(currentSlide !== 'additionaleducationdetails_' + i) ? true:false">
          <additional-education-details [group]="additionalEducationForm.get('additionalEducationSubForm')['controls'][i]" [row]="i" 
            [options]="options[i]" [configOptions]="configOptions" [isReviewAdd]="isReviewAdd" [isEmploymentGapInDaysEnabled]="isEmploymentGapInDaysEnabled"
            [dateOptions]="dateConfigs[i]" [isReviewEdit]="isReviewEdit" [isReview]="isReview" [zipCodeError]="zipCodeError"
            (onSaveExit)="saveExit()" (onAdditionalEducationDetails)="empAdditionalEducationDetails($event)"
            (onAdditionalEducationDetailsSwipe)="empAdditionalEducationDetailsSwipe($event)"
            (onMakeServerValidator)="handleMakeServerValidator($event)">
          </additional-education-details>
        </div>
        
        <div class="mobile_container animated posrel"
          [class.slideInRight]="(currentSlideWithDirection  === 'additionaleducationreconfirm_' + i + '_right') ? true:false"
          [class.slideInLeft]="(currentSlideWithDirection  === 'additionaleducationreconfirm_' + i + '_left') ? true:false"
          [class.hide]="(currentSlide  !== 'additionaleducationreconfirm_' + i) ? true:false">
          <additional-education-reconfirm 
            [group]="additionalEducationForm.get('additionalEducationSubForm')['controls'][i]" [row]="i" [configOptions]="configOptions"
            (onAdditionalEducationReconfirm)="empAdditionalEducationReconfirm($event)" (onAdditionalEducationReconfirmSwipe)="empAdditionalEducationReconfirmSwipe($event)"
            (onSaveExit)="saveExit()">
          </additional-education-reconfirm>
        </div>
      </div>
    </div>
  </div>
</form>




